__turbopack_context__.v({
  "bottom": "CheesePull-module-scss-module__e7fImG__bottom",
  "cheese": "CheesePull-module-scss-module__e7fImG__cheese",
  "fade-in": "CheesePull-module-scss-module__e7fImG__fade-in",
  "root": "CheesePull-module-scss-module__e7fImG__root",
  "top": "CheesePull-module-scss-module__e7fImG__top",
});
